import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import SettingPage from '../modules/apps/settings/SettingsPage'
import MaketingPage from '../modules/apps/product-passport/productions-modules/MaketingPage'
import TransactionsPage from '../modules/apps/transactions/TransactionsPage'
import { useAuth } from '../modules/auth'
import ProtectedSpecificRoute from './NestedPrivateRoutes'
import WasteCollectorPage from '../modules/apps/waste-collector/WasteCollectorPage'
// import FacilityPage from '../modules/apps/waste-collector/FacilityPage'
import WasteCollectorPageC from '../modules/apps/waste-collector/CustomaersPage'
import ReportsCollectorPage from '../modules/apps/reports/ReportsPage'
import ImpactPage from '../modules/apps/impact/ImpactPage'
import MassBalancerPage from '../modules/apps/mass-balancer/MassBalancerPage'
import ProductPassportPage from '../modules/apps/product-passport/ProductPassportPage'
import ISSEUMenuPage from '../modules/apps/mass-balancer/ISSEUPage'
import { LeaderboardWrapperC } from '../modules/apps/data-administration/data-admininstration-list/leaderboard/leaderboardlistC'
import { FacFor } from '../modules/apps/data-administration/data-admininstration-list/leaderboard/FacFor'
import { SponsorDash } from '../modules/apps/data-administration/data-admininstration-list/leaderboard/SponsorDash'
import FacilityPage from '../modules/apps/waste-collector/FacilityPage'
import PaymentPage from '../modules/accounts/components/settings/cards/PaymentPage'
import ShowcaseForm from '../modules/apps/data-administration/data-admininstration-list/form-edit-modal/ShowcaseForm'
import CommitmentForm1 from '../modules/apps/data-administration/data-admininstration-list/form-edit-modal/CommitmentForm'
import RewardsPage from '../modules/apps/settings/Rewards/RewardsPage'
import BDPage from '../modules/apps/data-administration/data-admininstration-list/Business-Devlopment/BDpage'

import { FulfillmentStatusDetailPage } from '../modules/apps/data-administration/data-admininstration-list/leaderboard/FulfillmentStatusDetailPage'
const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const DataAdministrationPage = lazy(
    () => import('../modules/apps/data-administration/DataAdminstrationPage')
  )
  const OperationManagementPage = lazy(
    () => import('../modules/apps/operations-management/OperationManagementPage')
  )
  const { currentUser, isPartner }: any = useAuth()

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
        <Route
          path='auth/*'
          element={
            <Navigate to={(currentUser as any)?.userType === 'SPONSOR' ? '/My-impact' : '/dashboard'} />
          }
        />
        <Route
          path='My-impact'
          element={
            <ProtectedSpecificRoute>
              <SponsorDash />
            </ProtectedSpecificRoute>
          }
        />

        {/*  <Route
          path='auth/*'
          element={
            <Navigate to={currentUser?.userType === 'ADMIN' ? '/apps/stock' : '/dashboard'} />
          }
        /> */}
        {/* Pages */}
        {/* <Route path='dashboard' element={<DashboardWrapper />} /> */}

        {/* 
        <Route
          path='dashboard'
          element={
            <ProtectedSpecificRoute>
              <DashboardWrapper />
            </ProtectedSpecificRoute>
          }
        /> */}

        {/* <Route
          path='dashboard'
          element={
            <ProtectedSpecificRoute>
              {currentUser?.userType === 'PICKUP_POINT_STAFF' ? (
                <FacFor />
              ) : (
                <DashboardWrapper />
              )}
            </ProtectedSpecificRoute>
          }
        /> */}

        <Route
          path='dashboard'
          element={
            <ProtectedSpecificRoute>
              {(currentUser as any)?.userType === 'SPONSOR' ? (
                <SponsorDash />
              ) : (currentUser as any)?.userType === 'PICKUP_POINT_STAFF' ? (
                <FacFor />
              ) : (
                <DashboardWrapper />
              )}
            </ProtectedSpecificRoute>
          }
        />

        <Route path='data-administration' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/makting/engagement/add-engagement'
          element={
            <SuspensedView>
              <ShowcaseForm />
            </SuspensedView>
          }
        />


        <Route
          path='/apps/business-development/fullfilment/status'
          element={<FulfillmentStatusDetailPage />}
        />


        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/transactions/*'
          element={
            <SuspensedView>
              <TransactionsPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/iscceu/*'
          element={
            <SuspensedView>
              <ISSEUMenuPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/product-passport/*'
          element={
            <SuspensedView>
              <ProductPassportPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/commitment/new'
          element={
            <SuspensedView>
              <CommitmentForm1 />
            </SuspensedView>
          }
        />
        <Route
          path='apps/settings/*'
          element={
            <SuspensedView>
              <SettingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/makting/*'
          element={
            <SuspensedView>
              <MaketingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/reports/*'
          element={
            <SuspensedView>
              <ReportsCollectorPage />
            </SuspensedView>
          }
        />
        {!isPartner && (
          <Route
            path='apps/impact/*'
            element={
              <SuspensedView>
                <ImpactPage />
              </SuspensedView>
            }
          />
        )}
        <Route
          path='apps/waste-source/*'
          element={
            <SuspensedView>
              <WasteCollectorPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/customers/*'
          element={
            <SuspensedView>
              <WasteCollectorPageC />
            </SuspensedView>
          }
        />

        <Route path='/payment' element={<PaymentPage />} />
        <Route
          path='apps/mass-balancer/*'
          element={
            <SuspensedView>
              <MassBalancerPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/facility'
          element={
            <SuspensedView>
              <FacilityPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/rewards/*'
          element={
            <SuspensedView>
              <RewardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/business-development/*'
          element={
            <SuspensedView>
              <BDPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/*'
          element={
            <SuspensedView>
              <DataAdministrationPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/order-management/*'
          element={
            <SuspensedView>
              <OperationManagementPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
